import { type Signal, useComputed } from "@suse-o11y/signal";

import { findLast } from "~/tools/find-last";
import { isPresent } from "~/tools/is-present";
import { map } from "~/tools/map";
import { pipe } from "~/tools/pipe";
import { useRequiredContext } from "~/tools/use-required-context";

import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";

import { ExplorationDrawerStateContext } from "./_exploration-drawer-state-context";

export function useNearestMetricsDrawerTimeRange(): undefined | Signal<TimeRange> {
	const { drawers } = useRequiredContext(ExplorationDrawerStateContext, {
		providerName: "ExplorationDrawerStateProvider",
	});

	return useComputed(
		(monitor) =>
			pipe(
				drawers.read(monitor),
				map(({ metrics, boundMetrics }) => metrics?.timeRange ?? boundMetrics?.timeRange),
				findLast(isPresent),
			),
		[drawers],
	);
}
